import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import Config from '../../configs/config';

export default {
    namespace: 'search',

    state: {},

    effects: (dispatch: any) => ({
        fetchSearch(q: string) {
            return actionWrapper(
                 () => {
                    return axios({
                        method: 'get',
                        url: `${Config.geoApiUrl}&q=${q || ''}`,
                    });
                },
                dispatch.util.errorHandler,
            );
        },
    }),

    reducers: {},
};
